import { validate } from 'vee-validate';
import moment from 'moment';
import { Event,LogFilter,Utils } from './assets/js';
import API from './libs/coms/';
import Session from './libs/session'
import notifications from './libs/notifications'
import countries from './countries'

export default class Packages {
   constructor(Vue) {
      global.moment = moment
      this.vue = Vue
      this.initializeLocalAssets()
      this.notifications()
      this.session()
      this.remoteComs()
      this.validator()
      this.clarks()
   }

   initializeLocalAssets(){
      // global.Event = new Event(this.vue)
      global.Event = this.vue
      global.utils = new Utils()
   }

   notifications(){
      global.$notify = notifications.notify
   }

   validator(){
      const rules = require('./libs/validator/rules')
      global.validate = validate;
   }

   session(){
      global.$session = new Session();
   }

   remoteComs(){
      global.api = new API()
   }

   fetchCountries() {
      return new Promise(async (resolve, reject) => {
         try {
            await utils.cleanAndStoreCountries(countries,'Rwanda')
            resolve(countries)
         } catch (error) {
            reject(error)
         }
      });
   }

   async clarks(){
      await this.fetchCountries()
   }
}